// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Coupon_Types_Id from "../Restaumatic.Coupon.Types.Id/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Coupon_Types_Id.eqCouponId);
var codeIsSymbol = {
    reflectSymbol: function () {
        return "code";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var CouponIsSymbol = {
    reflectSymbol: function () {
        return "Coupon";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var Coupon = function (x) {
    return x;
};
var toFillFormTypeCoupon = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeCoupon_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCoupon = function (dictHasField) {
    return dictHasField;
};
var eqCoupon = {
    eq: function (x) {
        return function (y) {
            return x.code === y.code && eq1(x.id)(y.id);
        };
    }
};
var genericCoupon = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCoupon = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCoupon)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(codeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(idIsSymbol)(Restaumatic_Coupon_Types_Id.showCouponId))(Data_Show.showString))))(CouponIsSymbol))
};
var unscrambleDecodeCoupon = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCoupon)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(codeIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(idIsSymbol)(Restaumatic_Coupon_Types_Id.udecodeCouponId)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeCoupon = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCoupon)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CouponIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(idIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Coupon_Types_Id.encodeCouponId)))(codeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var decodeCoupon = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCoupon)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CouponIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(idIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Coupon_Types_Id.decodeCouponId))())(codeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    Coupon,
    genericCoupon,
    eqCoupon,
    showCoupon,
    encodeCoupon,
    decodeCoupon,
    unscrambleDecodeCoupon,
    toFillFormTypeCoupon,
    hasFieldCoupon,
    newtypeCoupon_
};
